import {
  Badge,
  Button,
  CssBaseline,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Tooltip,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  LicenseInfo,
  DataGridPro,
  GridFilterPanel,
  getGridStringOperators,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector
} from "@mui/x-data-grid-pro";
import { CommonService } from "../../../services";
import { LoggedInUserDetails } from "../../common/LoggedInUserDetails/LoggedInUserDetails";
import Alert from "@mui/lab/Alert";
import { useHistory } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import useStyles from "../../common/CommonStyle/CommonStyle";
import { FormattedMessage, useIntl } from "react-intl";
import GridTextLocalization from "../../common/GridTextLocalization/GridTextLocalization";
import { SupportedLanguageDetails } from "../../common/SupportedLanguageDetails/SupportedLanguageDetails";
import CommonGridPagination from "../../common/CommonGridPagination/CommonGridPagination";
import { ModuleAccessPermissionKey } from "../../../Constants/ModuleAccessKey";
import CommonBackDrop from "../../common/BackDrop";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import saveAs from "file-saver";

const columnFieldsName = {
  poTransmissionHdrId: "poTransmissionHdrId",
  bpName: "bpName",
  bpType: "bpType",
  projectCode: "projectCode",
  remarks: "remarks",
  poNo: "poNo",
  poDate: "poDate",
  createdBy: "createdBy",
  createdTime: "createdTime",
  updatedBy: "updatedBy",
  updatedTime: "updatedTime",
  erpOrgCode: "organization.erpOrgCode",
  erpEntityCode: "entity.erpEntityCode",
  fileName: "fileName"
};

function PoTransmissionHdrDrpDn(props) {
  const { poTransmissionHdrId } = props;
  const classes = useStyles();
  const history = useHistory();
  const intl = useIntl();
  const theme = useTheme();
  const X_GRID_LICENSE_KEY = `${process.env.REACT_APP_X_GRID_LICENSE_KEY}`.toString();
  LicenseInfo.setLicenseKey(X_GRID_LICENSE_KEY);
  const selectedLanguage = useContext(SupportedLanguageDetails);
  const localtext = GridTextLocalization();
  const pageLabelsConstantsAndMessages = {
    alignment: {
      alignLeft: "left",
      alignRight: "right",
      alignCenter: "center"
    }
  };
  const mobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedRow, setSelectedRow] = React.useState([]);
  const moduleAccessKeyPermission = ModuleAccessPermissionKey();
  const { loggedInUserInfo } = useContext(LoggedInUserDetails);
  const invoiceModuleAccess =
    loggedInUserInfo.roleModuleAccess[moduleAccessKeyPermission.invoiceInbound];
  const [alertBoxState, setAlertBoxState] = React.useState({
    openAlert: false,
    vertical: "top",
    horizontal: "center",
    message: "",
    severity: ""
  });
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [searchedEntityCode, setSearchedEntityCode] = useState("");
  const [searchedStatusFlag, setSearchedStatusFlag] = useState("");
  const [
    searchedApprovedRecordsRecords,
    setSearchedApprovedRecordsRecords
  ] = useState(null);
  const [searchedBpName, setSearchedBpName] = useState("");
  const handleCloseAlert = () => {
    setAlertBoxState({ ...alertBoxState, openAlert: false });
  };
  const { vertical, horizontal, openAlert, message, severity } = alertBoxState;
  const [refreshTable, setRefreshTable] = useState(false);
  const [tableLoadingStatus, setTableLoadingStatus] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [chipInfoList, setChipInfoList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [disableApproveButton, isDisableApproveButton] = useState(true);
  const [openFilterPanel, setFilterPanel] = useState(false);
  const [searchedPoNo, setSearchedPoNo] = useState("");
  const [searchedPoDate, setSearchedPoDate] = useState("");
  const [searchedProjectCode, setSearchedProjectCode] = useState("");
  const [searchedCreatedTime, setSearchedCreatedTime] = useState("");

  const handleCloseForFilter = () => {
    setFilterPanel(false);
  };
  const [filterCount, setFilterCount] = React.useState(0);
  var defaultEntity = loggedInUserInfo.defaultEntity;
  const defaulSelectedFilters = [];

  const [selectedFilters, setSelectedFilters] = useState(defaulSelectedFilters);

  const [paramBody, setParamBody] = useState({
    pageNo: 0,
    sortDir: "desc",
    sortKey: "updatedTime",
    recordsPerPage: 25
  });

  const commonColumnForPoTransmissionDrpDn = [
    // {
    //   field: "action",
    //   headerName: intl.formatMessage({ id: "columnname.action.label" }),
    //   width: 100,
    //   sortable: false,
    //   hide: false,
    //   headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   filterable: false,
    //   renderHeader: CommonService.customRenderHeaderColumns,
    //   renderCell: cellParams => (
    //     <div>
    //       {(invoiceModuleAccess !== undefined
    //         ? invoiceModuleAccess.readFlag
    //         : false) && (
    //         <Tooltip
    //           title={
    //             <FormattedMessage id="common.button.view.breadcrumb.tooltip" />
    //           }
    //           placement="bottom"
    //           className={classes.actionButton}
    //           onClick={() => {
    //             let msgId = cellParams.row.msgId;
    //             history.push(`/invoiceInboundDtls/${msgId}`, {
    //               mode: "view",
    //               msgId: msgId
    //             });
    //           }}
    //         >
    //           <span>
    //             <IconButton className={classes.customeToolbar} size="large">
    //               <ViewIcon />
    //             </IconButton>
    //           </span>
    //         </Tooltip>
    //       )}
    //     </div>
    //   )
    // },
    {
      field: "file",
      headerName: intl.formatMessage({ id: "columnname.file.label" }),
      width: 100,
      sortable: false,
      hide: false,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => (
        <div>
          {cellParams.row.downloadFilePath !== null && (
            <Tooltip
              title={
                <FormattedMessage
                  id="common.tooltip.breadcrumb.downloadPdf"
                  defaultMessage="downloadPdf"
                />
              }
              placement="bottom"
              className={classes.actionButton}
              onClick={() => {
                showPdf(cellParams.row.downloadFilePath);
              }}
            >
              <span>
                <IconButton className={classes.customeToolbar} size="large">
                  <PictureAsPdfIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      )
    },
    // {
    //   field: columnFieldsName.erpEntityCode,
    //   headerName: intl.formatMessage({ id: "columnname.entitycode.label" }),
    //   headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
    //   width: 85,
    //   sortable: false,
    //   type: "string",
    //   hide: true,
    //   filterable: true,
    //   valueGetter: params => `${params.row.entity.erpEntityCode}`,
    //   renderHeader: CommonService.customRenderHeaderColumns
    // },
    {
      field: columnFieldsName.poNo,
      width: 190,
      headerName: intl.formatMessage({ id: "columnname.pono.label" }),
      sortable: false,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignRight}`,
      type: "string",
      hide: false,
      filterable: true,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.poDate,
      width: 165,
      headerName: intl.formatMessage({ id: "columnname.podate.label" }),
      sortable: false,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      type: "string",
      hide: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => <span>{cellParams.row.poDtDisp}</span>
    },
    {
      field: columnFieldsName.projectCode,
      headerName: intl.formatMessage({ id: "common.textfield.column.project" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 90,
      sortable: false,
      type: "string",
      hide: false,
      filterable: true,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.fileName,
      width: 400,
      headerName: intl.formatMessage({
        id: "columnname.poPdfFileName.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      sortable: false,
      type: "string",
      hide: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.remarks,
      headerName: intl.formatMessage({ id: "columnname.remarks.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 300,
      sortable: false,
      type: "string",
      hide: true,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    // {
    //   field: columnFieldsName.updatedBy,
    //   headerName: intl.formatMessage({ id: "columnname.updatedby.label" }),
    //   headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
    //   width: 155,
    //   sortable: true,
    //   type: "string",
    //   hide: false,
    //   filterable: false,
    //   renderHeader: CommonService.customRenderHeaderColumns
    // },
    // {
    //   field: columnFieldsName.updatedTime,
    //   headerName: intl.formatMessage({ id: "columnname.updateddate.label" }),
    //   headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
    //   width: 180,
    //   sortable: true,
    //   type: "string",
    //   hide: false,
    //   filterable: false,
    //   renderHeader: CommonService.customRenderHeaderColumns,
    //   renderCell: cellParams => <span>{cellParams.row.updatedTimeDisp}</span>
    // },
    {
      field: columnFieldsName.createdBy,
      headerName: intl.formatMessage({
        id: "columnname.columnnamecreatedby.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 155,
      sortable: false,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.createdTime,
      headerName: intl.formatMessage({
        id: "columnname.columnnamePOFileRcvDate.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 180,
      sortable: false,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => <span>{cellParams.row.createdDtDisp}</span>
    }
  ];

  const showPdf = filePath => {
    const filePathReplaceWithDoubleBackwardSlash = filePath.replaceAll(
      "\\",
      "/"
    );
    const fileName = filePathReplaceWithDoubleBackwardSlash
      .split("/")
      [filePathReplaceWithDoubleBackwardSlash.split("/").length - 1].trim();
    fetch(
      `${process.env.REACT_APP_API_URL}/downloadFileFromServer?filePath=${filePathReplaceWithDoubleBackwardSlash}`,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + CommonService.getJwtTokenOfLoggedInUser()
        }
      }
    )
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="successmessage.dowload"
              defaultMessage="File downloaded successfully"
            />
          ),
          severity: "success"
        });
        saveAs(blob, fileName);
        var url = URL.createObjectURL(blob);
        window.open(url, fileName);
      })
      .catch(error => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="errorMessage.download"
              defaultMessage="Failed to download the file!"
            />
          ),
          severity: "error"
        });
      });
  };

  useEffect(() => {
    setColumns(commonColumnForPoTransmissionDrpDn);
  }, [selectedLanguage]);

  useEffect(() => {
    setTableLoadingStatus(true);
    setTableData([]);
    CommonService.GetListApi(
      `/poTransmissionDtls/${poTransmissionHdrId}/poTransmissionDtls`,
      paramBody
    )
      .then(response => {
        setTotalRowCount(response.data.totalElements);
        setTableLoadingStatus(false);
        setTableData(response.data.content);
        response.data.totalElements > 0
          ? setChipInfoList(
              response.data.content[0].headerChipList === null
                ? []
                : response.data.content[0].headerChipList
            )
          : setChipInfoList([]);
      })
      .catch(function(error) {
        setTableLoadingStatus(false);
        if (error.response !== undefined) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.data.message,
            severity: "error"
          });
        }
      });
  }, [paramBody, refreshTable]);

  function currentlySelectedRow(selections) {
    setSelectedRow(selections);
    if (selections.length === 0) {
      isDisableApproveButton(true);
    } else {
      isDisableApproveButton(false);
    }
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openAlert}
        onClose={handleCloseAlert}
        key={vertical + horizontal}
        autoHideDuration={5000}
      >
        <Alert onClose={handleCloseAlert} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <CommonBackDrop open={openBackDrop} />
      <Grid container className={classes.rootForRole} style={{ width: "50%" }}>
        <Paper
          elevation={3}
          className={classes.gridHeightAndWidthForASNDropDown}
        >
          <div style={{ height: "100%", width: "100%" }}>
            <DataGridPro
              className={classes.customTableStyle}
              sortingMode="server"
              rows={tableData}
              columns={columns}
              showToolbar
              pageSize={paramBody.recordsPerPage}
              loading={tableLoadingStatus}
              rowCount={totalRowCount}
              getRowId={row => row.poTransmissionDtlId}
              scrollbarSize={30}
              disableColumnFilter={true}
              rowsPerPageOptions={[1, 2, 10, 25, 50, 100]}
              pagination
              density="compact"
              paginationMode="server"
              disableSelectionOnClick={true}
              disableMultipleColumnsSorting={true}
              isRowSelectable={params =>
                params.row.approved === 0 ? true : false
              }
              hideFooter={true}
              //checkboxSelection={true}
              onSelectionModelChange={currentlySelectedRow}
              selectionModel={selectedRow}
              localeText={localtext}
              components={{
                Toolbar: () => {
                  return (
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      style={
                        mobileScreen
                          ? { marginBottom: "-0.1%", marginTop: "0%" }
                          : { marginBottom: "-0.3%", marginTop: "-0.5%" }
                      }
                    >
                      <Grid
                        item
                        container
                        direction="row"
                        justifyContent="flex-start"
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                      >
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.columntoolbar.tooltip" />
                            }
                            placement="bottom"
                          >
                            <GridToolbarColumnsButton
                              className={classes.toobarStyle}
                              variant="outlined"
                              size="medium"
                            />
                          </Tooltip>
                        </Grid>
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage id="common.density.tooltip" />
                            }
                            placement="bottom"
                          >
                            <GridToolbarDensitySelector
                              className={classes.toobarStyle}
                              variant="outlined"
                              size="medium"
                            />
                          </Tooltip>
                        </Grid>
                        <Grid>
                          <Tooltip
                            title={
                              <FormattedMessage
                                id="common.button.refresh.tooltip"
                                defaultMessage="Refresh"
                              />
                            }
                            placement="bottom"
                          >
                            <span>
                              <Button
                                size="small"
                                color="primary"
                                variant="outlined"
                                className={classes.refreshToobarStyle}
                                onClick={() => {
                                  setRefreshTable(!refreshTable);
                                  setSelectedRow([]);
                                }}
                              >
                                <RefreshIcon />
                              </Button>
                            </span>
                          </Tooltip>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <CommonGridPagination />
                      </Grid>
                    </Grid>
                  );
                }
              }}
              hideFooterSelectedRowCount={true}
              onPageSizeChange={pageParams => {
                setParamBody(prevState => {
                  return { ...prevState, recordsPerPage: pageParams };
                });
              }}
              onPageChange={pageParams => {
                setParamBody(prevState => {
                  return { ...prevState, pageNo: pageParams };
                });
              }}
              sortingOrder={["desc", "asc"]}
              filterMode="server"
              onFilterModelChange={async params => {
                let filterModelItem = params.items;
                if (filterModelItem.length > 0) {
                  let projectCode = null;
                  let bpName = null;
                  let poDate = null;
                  let poNo = null;
                  let createdTime = null;
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.poNo
                    ) {
                      poNo =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : filterModelItem[index].value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.poDate
                    ) {
                      poDate =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : JSON.parse(filterModelItem[index].value).value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.projectCode
                    ) {
                      projectCode =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : JSON.parse(filterModelItem[index].value).value;
                      break;
                    }
                  }
                  for (let index = 0; index < filterModelItem.length; index++) {
                    if (
                      filterModelItem[index].columnField ===
                      columnFieldsName.createdTime
                    ) {
                      createdTime =
                        (await filterModelItem[index].value) === undefined
                          ? ""
                          : JSON.parse(filterModelItem[index].value).value;
                      break;
                    }
                  }
                  setSearchedBpName(bpName);
                  setSearchedPoDate(poDate);
                  setSearchedPoNo(poNo);
                  setSearchedProjectCode(projectCode);
                  setSearchedCreatedTime(createdTime);
                }
              }}
            />
          </div>
        </Paper>
      </Grid>
    </React.Fragment>
  );
}

export default PoTransmissionHdrDrpDn;
